import React from 'react';
import Icon from '../Icon/Icon';
import Box from '../Box/Box';

import type { TEFeedbackSignal } from '../../types/TEFeedbackSignal';
import { TIcon } from '../../types/TStyleVariables';

type TInlineFeedbackIcon = {
  icon: TIcon;
  signal: TEFeedbackSignal;
};

const InlineFeedbackIcon = ({ icon, signal }: TInlineFeedbackIcon) => (
  <Box as="div" parent="InlineFeedback" name="icon">
    <Icon name={icon} color={signal} />
  </Box>
);

export default InlineFeedbackIcon;
